"use client"

import { useEffect } from "react"
import { toast } from "sonner"

import { analytics } from "@/lib/analytics/client"
import { isIgnoredError } from "@/lib/analytics/ignored-errors"
import { recordSessionError } from "@/lib/analytics/session-diagnostics"

export function GlobalErrorHandler() {
  useEffect(() => {
    function handleError(event: ErrorEvent) {
      const error = event.error ?? new Error(event.message)
      if (isIgnoredError(error)) {
        console.debug("[GlobalErrorHandler] ignored:", error)
        return
      }
      console.error("[GlobalErrorHandler] uncaught error:", error)
      analytics.captureException(error)
      // Guardado também aqui porque o relato do beta tester chega sem stack: o
      // botão de reportar problema lê este buffer e anexa ao e-mail.
      recordSessionError(error, "error")
      toast.error("Erro inesperado. Tente recarregar a página.")
    }

    function handleUnhandledRejection(event: PromiseRejectionEvent) {
      const error =
        event.reason instanceof Error
          ? event.reason
          : new Error(String(event.reason))
      if (isIgnoredError(event.reason) || isIgnoredError(error)) {
        console.debug("[GlobalErrorHandler] ignored rejection:", error)
        return
      }
      console.error("[GlobalErrorHandler] unhandled rejection:", error)
      analytics.captureException(error)
      recordSessionError(error, "unhandledrejection")
      toast.error("Erro inesperado. Tente recarregar a página.")
    }

    window.addEventListener("error", handleError)
    window.addEventListener("unhandledrejection", handleUnhandledRejection)

    return () => {
      window.removeEventListener("error", handleError)
      window.removeEventListener("unhandledrejection", handleUnhandledRejection)
    }
  }, [])

  return null
}
